import { useState } from "react";
//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
//CONTEXT;
import { useCreativeState, useCreativeDispatch } from "../../../../contexts/creative.context";
//ASSETS
import studio_config from "../../../../configs/studio.json";
//TYPES
export interface StudioConfig {
  [key: string]: any;
}

interface ExtraFeaturesProps {
  children?: React.ReactNode;
}

export default function ExtraFeatures({ children }: ExtraFeaturesProps) {
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();
  const [featuresToggleOpen, setFeaturesToggleOpen] = useState(true);
  const studioConfig: StudioConfig = studio_config;

  return (
    <>
      <ComponentLibrary.PCContainerMain borderRadiusDirection={"bottom"}>
        <ComponentLibrary.PCContainerMain>
          <div className="flex">
            <ComponentLibrary.PCHeader text={"Extra features"} />
            <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={4} />
            <button onClick={() => setFeaturesToggleOpen(!featuresToggleOpen)} className="color-primary-3 pointer width-4 self-center bg-transparent bn">
              <ComponentLibrary.PCIconPicker icon={featuresToggleOpen ? "chevron-down" : "chevron-right"} />
            </button>
          </div>
          {featuresToggleOpen ? (
            <div>
              {
                <>
                  <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
                  <ComponentLibrary.PCDivider />
                  <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={4} />
                  <div className="flex">
                    <div className="margin-right-3 color-text-5 flex items-center">
                      <ComponentLibrary.PCIconPicker icon={["far", "smile"]} />
                    </div>
                    <p className="text-size-3 color-text-5 platform-font ma0 fw5 margin-right-3 flex items-center">{"Emoji reaction bar"}</p>
                    <p className="text-size-2 color-text-2 platform-font ma0 fw4 flex items-center">{"3 emojis min"}</p>
                    <div className="ml-auto">
                      <ComponentLibrary.PCToggle
                        id={"emojiFeatures"}
                        toggle={creative.metadata.features.reactions.visible}
                        handleToggle={() => {
                          creativeDispatch({
                            type: "UPDATE_CREATIVE_METADATA_FEATURES_REACTIONS_VISIBLE",
                            payload: { visible: !creative.metadata.features.reactions.visible },
                          });
                        }}
                        toggleColor={"#f8506f"}
                        toggleLabel={false}
                        isDisabled={!studioConfig.formats[creative.metadata.format]?.inputs.features.reactions.supported}
                        isDisabledMessage={"This feature is not available on this format"}
                      />
                    </div>
                  </div>
                  {children}
                </>
              }
            </div>
          ) : null}
        </ComponentLibrary.PCContainerMain>
      </ComponentLibrary.PCContainerMain>
      <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
    </>
  );
}
